import "./NewProjectJourney.css";

import { Column, Row } from "../../../../widget";
import { NewProjectStepper } from "./components";
import { useNewProjectJourney } from "./useNewProjectJourney";

interface NewProjectJourneyProps {
  /** Shown beside the stepper. Left off by a host that has its own heading, such as a flyout panel. */
  title?: string;
}

/**
 * The embeddable journey: the stepper and whichever step is current. Renders inside a
 * NewProjectJourneyProvider, which owns the state and tells the host when the journey completes.
 * The page chrome (template, user header) belongs to the host - see NewProjectJourneyPage.
 */
export const NewProjectJourney = ({ title }: NewProjectJourneyProps): JSX.Element => {
  const { CurrentStep, hasStepper } = useNewProjectJourney();

  return (
    <div className="NewProjectJourney">
      {(title || hasStepper) && (
        <Row spacingV="ll">
          <Column span={12} className="NewProjectJourney_titleRow">
            {title && <h1>{title}</h1>}
            {hasStepper && <NewProjectStepper />}
          </Column>
        </Row>
      )}

      <CurrentStep />
    </div>
  );
};
